"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeetingsSwaggerMetadata = exports.deleteMeetingSwaggerMetadata = exports.getMeetingByIdSwaggerMetadata = exports.updateMeetingSwaggerMetadata = exports.createMeetingSwaggerMetadata = void 0;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const create_meeting_dto_1 = require("./dto/create-meeting.dto");
const update_meeting_dto_1 = require("./dto/update-meeting.dto");
const meeting_response_dto_1 = require("./dto/meeting-response.dto");
const get_meetings_dto_1 = require("./dto/get-meetings.dto");
const createMeetingSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_meeting_dto_1.CreateMeetingDto), (0, swagger_1.ApiOperation)({
        summary: "Create a new meeting",
        description: "Create a new meeting",
    }), (0, swagger_1.ApiBody)({
        description: "Meeting data",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_meeting_dto_1.CreateMeetingDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: messages_1.successMessage.meetingCreation,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: { type: "string", example: messages_1.successMessage.meetingCreation },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.meetingCreationFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.meetingCreationFailed,
                },
            },
        },
    }));
};
exports.createMeetingSwaggerMetadata = createMeetingSwaggerMetadata;
const updateMeetingSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(update_meeting_dto_1.UpdateMeetingDto), (0, swagger_1.ApiOperation)({
        summary: "Update a meeting",
        description: "Update a meeting",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Meeting ID",
        type: Number,
    }), (0, swagger_1.ApiBody)({
        description: "Meeting data",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(update_meeting_dto_1.UpdateMeetingDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.meetingUpdated,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.meetingUpdated },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.meetingUpdateFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.meetingUpdateFailed,
                },
            },
        },
    }));
};
exports.updateMeetingSwaggerMetadata = updateMeetingSwaggerMetadata;
const getMeetingByIdSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(meeting_response_dto_1.MeetingDto), (0, swagger_1.ApiOperation)({
        summary: "Get meeting by ID",
        description: "Get meeting by ID",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Meeting ID",
        type: Number,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.meetingDetails,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.meetingDetails },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(meeting_response_dto_1.MeetingDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.meetingNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.meetingNotFound },
            },
        },
    }));
};
exports.getMeetingByIdSwaggerMetadata = getMeetingByIdSwaggerMetadata;
const deleteMeetingSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Delete a meeting",
        description: "Delete a meeting",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Meeting ID",
        type: Number,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.meetingDeleted,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.meetingDeleted },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.meetingNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.meetingNotFound },
            },
        },
    }));
};
exports.deleteMeetingSwaggerMetadata = deleteMeetingSwaggerMetadata;
const getMeetingsSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Get all meetings",
        description: "Get all meetings",
    }), ...Object.keys(get_meetings_dto_1.GetMeetingsDto.prototype).map((key) => (0, swagger_1.ApiQuery)({
        name: key,
        required: false,
        description: Reflect.getMetadata("swagger/apiModelProperties", get_meetings_dto_1.GetMeetingsDto.prototype, key)?.description,
        example: Reflect.getMetadata("swagger/apiModelProperties", get_meetings_dto_1.GetMeetingsDto.prototype, key)?.example,
    })), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.meetingList,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.meetingList },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                $ref: (0, swagger_1.getSchemaPath)(meeting_response_dto_1.MeetingDto),
                            },
                        },
                        count: { type: "number", example: 10 },
                    },
                },
            },
        },
    }));
};
exports.getMeetingsSwaggerMetadata = getMeetingsSwaggerMetadata;
